<template>
    <a-select v-model:value="value" :mode="mode">
      <a-select-option :value='i' v-for='i of cpePlatforms' :key='i' >{{i}}</a-select-option>
    </a-select>
</template>
<script lang='ts' setup>
import { ref, defineProps, defineEmits, computed, onMounted, watch } from 'vue';
import request from '@/utils/request'


const cpePlatforms = ref([])

const props = defineProps({
  modelValue: {
    type: [String, Array],
  },
  mode: {
    type: String,
    default: '',
  },
})

const emits = defineEmits(['update:modelValue', 'changeValues'])

const value: any = computed({
  set(val) {
    emits('update:modelValue', val)
  },
  get() {
    return props.modelValue
  },
})
onMounted(async () => {
  await handleGetCpePlatforms()
})


async function handleGetCpePlatforms() {
  try {
    const res = await request.get(`/api/in/kol/cpe/admin/project/get_cpe_platform`)
    cpePlatforms.value = res.data
  } catch(err) {
    console.log('err')
  }
}
</script>
<style lang='scss' scoped>

</style>